import React from "react";
import { ProductReviewsSSR } from "tsi-common-react/src/apps/reviews/ProductReviewsSSR/index";

import { templates } from "@reactivated";

export const Template = (
    props: templates.ProductReviewsTemplate,
): React.JSX.Element => {
    return (
        <ProductReviewsSSR
            {...props}
            brand="Stearns &amp; Foster"
            isCollapsedView={true}
        />
    );
};
